import { render, staticRenderFns } from "./ProductMainCategory.vue?vue&type=template&id=fd3a48be&scoped=true&"
import script from "./ProductMainCategory.vue?vue&type=script&lang=ts&"
export * from "./ProductMainCategory.vue?vue&type=script&lang=ts&"
import style0 from "./ProductMainCategory.vue?vue&type=style&index=0&id=fd3a48be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3a48be",
  null
  
)

export default component.exports